export const HelpBannersItems = {
    "/dashboard": {
        quickstart: {
            key: 'quickstart'
        }
    },
    "/checklist/template/:templateId/edit": {
        // checklist_global_response: {
        //     key: 'checklist_global_response'
        // }
    },
    "/checklist/global-response/list": {
        checklist_global_response: {
            key: 'checklist_global_response'
        }
    },
    "/assignment/list": {
        assignments: {
            key: 'assignments'
        }
    },
    "/inspections": {
        reports: {
            key: 'reports'
        }
    },
    "/issues": {
        issues: {
            key: 'issues'
        }
    },
    "/assets": {
        assets: {
            key: 'assets'
        }
    },
    "/resources/global-lists": {
        resources_global_list: {
            key: 'resources_global_list'
        }
    },
    "/resources/filemanager": {
        resources_file_manager: {
            key: 'resources_file_manager'
        }
    },
    "/analytics/overview": {
        analytics_overview: {
            key: 'analytics_overview'
        }
    },
    "/analytics/issues": {
        analytics_issues: {
            key: 'analytics_issues'
        }
    },
    "/analytics/responses": {
        analytics_responses: {
            key: 'analytics_responses'
        }
    },
    "/analytics/reports": {
        analytics_reports: {
            key: 'analytics_reports'
        }
    },
    "/user/list": {
        user_management_users: {
            key: 'user_management_users'
        }
    },
    "/group/list": {
        user_management_groups: {
            key: 'user_management_groups'
        }
    },
    "/user/role": {
        user_management_roles: {
            key: 'user_management_roles'
        }
    },
    "/settings/organization": {
        settings_organisation: {
            key: 'settings_organisation'
        }
    },
    "/settings/checklist": {
        settings_checklist: {
            key: 'settings_checklist'
        }
    },
    "/settings/report": {
        settings_report: {
            key: 'settings_report'
        }
    },
    "/settings/user": {
        settings_user: {
            key: 'settings_user'
        }
    },
    "/settings/security": {
        settings_security: {
            key: 'settings_security'
        }
    },
    "/user/account-settings": {
        manage_account: {
            key: 'manage_account'
        }
    }
}